import React, { Component } from "react";
import PropTypes from "prop-types";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { camelCase } from "lodash";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import * as actions from "../store/actions/index";
import FormControl from "@material-ui/core/FormControl";
import withSizes from "react-sizes";
import upload from "../images/upload.svg";
import FileBase64 from 'react-file-base64';

const styles = (theme) => ({
  container: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent:'center',
    alignContent:'center'
  },
  root: {
    marginBottom: "6px",
    width: "100%",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: "300px",
    borderRadius: "5px",
    border: "0px",
  },
  button: {
    //margin: theme.spacing.unit,
  },
  card: {
    minWidth: 250,
    width: 400,
    height: 200,
    marginRight: 6,
    marginBottom: 6,
  },
  topLabel: {
    fontSize: 16,
  },
  helperText: {
    fontSize: 14,
  },
  inner: {
    position: "absolute",
    zIndex: 1,
  },
});

class UploadDoc extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    file: { name: "" },
    doc_name: null,
    lang: localStorage.getItem('language'),
    filesBase64: null,
    isDescriptionEntered: false
  };

  componentDidUpdate() {
    // if (this.props.uploaded){
    //     if(this.props.file){
    //         this.handleReset(null, this.props.file.file.name);
    //         this.props.SetFalseUploaded();
    //     }
    //     else{
    //         this.props.SetFalseUploaded();
    //     }
    // }
  }

  uploadFile = (event) => {
    let file = event.target.files[0];
    if (this.state.doc_name !== null){
      if (file) {
        let doc_name = this.state.doc_name;
        this.props.onAddFile(file, doc_name);
        this.setState({ file: file, doc_name: doc_name });
      }
    }else{
        alert(this.context.t("Please input the description before uploading file."))      
    }
  };

  handleReset = (event) => {
    // if (this.state.doc_name) {
      this.props.onResetFile(this.state.file);
    // } else {
    //   if (this.state.file) {
    //     this.props.onResetFile(this.state.file.name);
    //   }
    // }
    this.setState({
      file: { name: "" },
      doc_name: null,
      filesBase64: null,
      isDescriptionEntered: false
    });
  };

  handleResetAll = () => {
    this.setState({
      file: null,
      doc_name: null,
      filesBase64: null
    });
    this.props.toggleReset();
  };

  handleChange = (prop) => (event) => {
   
      this.setState({ [prop]: event.target.value });
      console.log([prop] +' '+ event.target.value)
      if (event.target.value !== ''){
        this.setState({
          isDescriptionEntered: true
        })
      }
      else{
        this.setState({
          isDescriptionEntered: false
        })
      }
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.reset) {
      this.handleResetAll();
    }
  }

  getFiles = (file) => {;
    if (this.state.doc_name !== null){
      if (file) {
        let doc_name = this.state.doc_name;
        console.log('This is file data')
        const r = (Math.random() + 1).toString(36).substring(7);

        console.log(file.name)
        let re = /(?:\.([^.]+))?$/;
        let ext = re.exec(file.name)[0];
        let filename = (''+file.name).replace(ext,'').replace(/\s/g,'').replace('&','').trim()
        let reFileName = filename
        let f = reFileName+'_'+ext
        file.name = f;
        console.log(f)

        this.props.onAddFile(file, doc_name);
        this.setState({ file: file, doc_name: doc_name });
      }
    }else{
        alert(this.context.t("Please input the description before uploading file."))      
    }
  }

  render() {
    const { classes } = this.props;
    console.log('index: '+this.props.index+' this.props.total: '+this.props.total)
    if (this.props.index !== (this.props.total-1)){
        return (
        <div className={classes.root}>
            <FormControl component="fieldset" className={classes.a}>
            <div className={classes.container}>
                <Grid
                  container
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                >
                <Grid item spacing={1}>
                    <div>
                    <div
                        className={classes.inner}
                        style={{
                        width: "115px",
                        height: "150px",
                        border: "2px solid white",
                        backgroundColor: "#6C0E21",
                        color: "white",
                        zIndex: 10,
                        fontSize: "11px",
                        pointerEvents: "none",
                        textAlign: "center",
                        verticalAlign: "center",
                        }}
                    >
                        {this.state.file == undefined && (
                        <img
                            width="20px"
                            style={{ marginTop: "50px" }}
                            src={upload}
                        ></img>
                        )}
                        {this.state.file !== undefined && (
                        <p style={{ marginTop: "50px" }}>
                            { this.state.file ? this.state.file.name : "" }
                        </p>
                        )}

                        <br></br>
                        <p style={{ fontSize: "10px" }}>
                        {this.context.t("uploadFileText")} 
                          {this.props.index + 1}
                        </p>
                        <br></br>
                    </div>
                    <div>
                        <input
                          type="file"
                          style={{ width: "115px", height: "150px" }}
                          onChange={this.uploadFile}
                          disabled={true}
                          accept=".jpg,.jpeg,.png,.gif,.bmp,.tiff,.tif,.webp,.heic,.heif,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf"
                        />
                        {this.state.isDescriptionEntered && <FileBase64
                          style={{ width: "115px", height: "150px" }}
                          onDone={ this.getFiles }
                        />}
                        
                    </div>
                  </div>
                </Grid>
                <Grid item spacing={1}>
                    <Typography
                    style={{
                        fontWeight: "bold",
                        fontSize: "11px",
                        color: "white",
                        marginLeft: "10px",
                    }}
                    >
                    {this.context.t("descriptionText1")}
                    {this.props.index + 1}
                    {this.context.t("descriptionText2")}
                    </Typography>
                    <textarea
                      className={classes.textField}
                      id="upload-file"
                      value={this.state.doc_name ? this.state.doc_name : ""}
                      onChange={this.handleChange("doc_name")}
                      placeholder={this.context.t("descriptionPlaceholder")}
                    ></textarea>
                </Grid>
                <Grid item spacing={1}>
                    <label onClick={this.handleReset} style={{ color: "white" }}>
                      {this.context.t("Reset")}
                    </label>
                </Grid>
                </Grid>
            </div>
            </FormControl>
        </div>
        );
    }
    else{
        console.log('return 000000')
        return (
            <div
              onClick={()=>{this.props.onAddIconClick()}}
              style={{
              marginLeft: this.props.isDesktop ? '110px' : '0px',
              width: "115px",
              height: "150px",
              border: "2px solid white",
              backgroundColor: "#6C0E21",
              color: "white",
              zIndex: 10,
              fontSize: "11px",
              textAlign: "center",
              verticalAlign: "center",
            }}
            >
                <p style={{ marginTop: "50px", fontSize:'25px', fontWeight:'bolder' }}> + </p>
            </div>
        )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    uploaded: state.uploadDocs.uploaded,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    SetFalseUploaded: () => dispatch(actions.SetFalseUploaded()),
  };
};

const mapSizesToProps = (sizes) => ({
  isMobile: withSizes.isMobile(sizes),
  isTablet: withSizes.isTablet(sizes),
  isDesktop: withSizes.isDesktop(sizes),
  isGtMobile: withSizes.isGtMobile(sizes),
  isGtTablet: withSizes.isGtTablet(sizes),
  isStTablet: withSizes.isStTablet(sizes),
  isStDesktop: withSizes.isStDesktop(sizes),
  isTabletAndGreater: withSizes.isTabletAndGreater(sizes),
  isTabletAndSmaller: withSizes.isTabletAndSmaller(sizes),
});

UploadDoc.contextTypes = {
  t: PropTypes.func,
};

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(withStyles(styles)(UploadDoc));

export default connect( mapStateToProps, mapDispatchToProps)(withSizes(mapSizesToProps)(withStyles(styles)((UploadDoc))));
